module.exports = __webpack_public_path__ + "e799201d59a3444b5570dadf29b0de21.svg";